import { render, staticRenderFns } from "./SupplierTop100Table.vue?vue&type=template&id=e2f5b8d4&"
import script from "./SupplierTop100Table.vue?vue&type=script&lang=js&"
export * from "./SupplierTop100Table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports